/*
  <ia-contentsquare-events> — artificial pageviews for overlays Contentsquare
  cannot see as navigations. Rendered by snippets/ia-contentsquare.liquid;
  data-pageviews maps a drawer id to the path recorded when that drawer opens
  (ia-drawer-opened). The Contentsquare tag itself is the app embed.
  It also hands every section with a "Section name" setting a stable override
  id (data-cs-override-id="section-<name as a slug>") unless the markup
  carries one already, so a merchant names a section once for the anchor
  links and the analytics tag alike.
*/
import { EVENTS, subscribe } from 'ia-util-pubsub'

class IaContentsquareEvents extends HTMLElement {
  connectedCallback() {
    this.nameSections()
    this.pageviews = this.readPageviews()
    this.unsubscribe?.()
    this.unsubscribe = subscribe(EVENTS.drawerOpened, this.handleDrawerOpened.bind(this))
  }

  disconnectedCallback() {
    this.unsubscribe?.()
    this.unsubscribe = null
  }

  nameSections() {
    document.querySelectorAll('[data-section-name]').forEach((el) => {
      if (el.dataset.csOverrideId) return
      const slug = el.dataset.sectionName.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
      if (slug) el.dataset.csOverrideId = `section-${slug}`
    })
  }

  readPageviews() {
    try {
      return JSON.parse(this.dataset.pageviews || '{}')
    } catch (error) {
      console.warn('[ia-contentsquare-events] data-pageviews is not valid JSON', error)
      return {}
    }
  }

  handleDrawerOpened(event) {
    const path = this.pageviews[event.detail?.drawerId]
    if (!path) return
    window._uxa = window._uxa || []
    window._uxa.push(['trackPageview', path])
  }
}

if (!customElements.get('ia-contentsquare-events')) {
  customElements.define('ia-contentsquare-events', IaContentsquareEvents)
}
